module.exports = __webpack_public_path__ + "static/media/checkThick-24-white.9f834e4b.svg";